import React, { useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { makeStyles } from "@mui/styles";
import styled from 'styled-components';
import { taskAttributes } from '@process-advisor/process-miner/processMiner/processMiner'

const useStyles = makeStyles((theme) => ({
    formControl: {
      width: 300,
      margin: 0,
    },
    listItemText:{
        fontSize:'12px',
    },
    menuItem: {
        height:"30px"
    },
    indeterminateColor: {
      color: "#f50057"
    },
    selectAllText: {
      fontWeight: 500,
      fontSize:'12px',
    },
    selectedAll: {
      backgroundColor: "rgba(0, 0, 0, 0.08)",
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.08)"
      }
    },
  }));

const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 2;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  },
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center"
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center"
  },
  variant: "menu"
};

export function AttributeSelect() {
  const classes = useStyles();
  const [selected, setSelected] = useState([]);
  const [options, setOptions] =  useState([]);

    React.useEffect(() => {
      const tOptions = taskAttributes();
      const values = tOptions.map(option => option.value);
      setOptions(tOptions);
      const current = apiProvider.getClusterAttributes();
      if (!current || current.length === 0 ) {
        apiProvider.setClusterAttributes({attributes: values, reProcess: false})
        setSelected(values)
      } else setSelected(current)
    }, []);

  const handleChange = (event) => {
    const value = event.target.value;
    setSelected(value);
  };

  const handleClose = (event) => {
    apiProvider.setClusterAttributes({attributes: selected, reProcess: true})
  };


  return (
    <FormControl sx={{ m: 1, minWidth: 200, height:'30px' }} size="small">
      <Select
        labelId="mutiple-select-label"
        multiple
        value={selected}
        onChange={handleChange}
        onClose={handleClose}
        renderValue={(selected) => selected.map(value => (options.find(option => option.value === value) || {}).label || value).join(", ")}
        style={{fontSize:'12px',height: '50px'}}
        MenuProps={MenuProps} 
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value} style={{height:'20px', minHeight:'30px'}}>
            <ListItemIcon style={{width:'.7em'}}>
              <Checkbox checked={selected.indexOf(option.value) > -1} />
            </ListItemIcon>
            <ListItemText classes={{ primary: classes.listItemText }} primary={option.label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

